exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".favorite {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  background: var(--gray-2);\n  transition: var(--transition);\n  cursor: pointer;\n  border-radius: 40px;\n}\n.favorite--active {\n  background: var(--red);\n}\n.favorite:hover {\n  background: var(--red);\n}\n.favorite .icon svg {\n  height: 13px;\n  width: 13px;\n}\n@media only screen and (max-width: 1024px) {\n.favorite {\n    width: 25px;\n    height: 25px;\n}\n}\n", ""]);

// exports
